import { Component, ElementRef, Input, Optional, Renderer, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInput } from 'ionic-angular/util/base-input';
import { Config, Form, Item, Modal, ModalController } from 'ionic-angular';
import * as _ from 'lodash';
import { AutoCompleteModalCmp } from './auto-complete-modal';

export interface AutoCompleteDataProvider {
  init(params: any): Promise<any>;
  loadItems(params: any): Promise<Array<any>>;
}


export class AutoCompleteCmp extends BaseInput<any> {
   dataProvider: AutoCompleteDataProvider;
   minChar: number = 2;
   placeholder: string = '';
   valueField: string = '';
   textField: string = '';
   providerParams: any = {};
   template: TemplateRef<any>;
   icon: string = '';
   iconColor: string = 'dodgerblue';
   showClear: boolean = false;

  keyword: string = '';

  private _modal: Modal;
  private isInit = true;

  constructor(
    config: Config,
    elementRef: ElementRef,
    renderer: Renderer,
    form: Form,
     item: Item,
    private modalCtrl: ModalController
  ) {
    super(config, elementRef, renderer, 'auto-complete', '', form, item, null);
  }

  clear() {
    this.keyword = '';
    this.value = null;
  }

  showModal() {
    this._modal = this.modalCtrl.create(AutoCompleteModalCmp, {
      options: {
        dataProvider: this.dataProvider,
        keyword: this.keyword,
        minChar: this.minChar,
        placeholder: this.placeholder,
        providerParams: this.providerParams,
        template: this.template
      }
    });
    this._modal.onDidDismiss(item => {
      if (!item) {
        return;
      }

      if (_.isObject(item)) {
        if (this.textField) {
          this.keyword = <string>_.get(item, this.textField);
        }
        if (this.valueField) {
          this.value = _.get(item, this.valueField);
        }
        return;
      }

      this.keyword = item;
      this.value = item;
    });
    this._modal.present();
  }

  _inputUpdated() {
    super._inputUpdated();

    if (!this.value || !this.isInit) {
      return;
    }

    this.isInit = false;

    this.dataProvider.init({
      initValue: this.value,
      ...this.providerParams
    }).then(result => {
      this.keyword = result;
    }).catch(e => console.log(e));
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ion-auto-complete',
  template: `
    <ion-input
      type="text"
      (tap)="showModal()"
      [(ngModel)]="keyword"
      [placeholder]="placeholder">
    </ion-input>
    <ion-icon *ngIf="showClear" item-end name="close" style="color: darkgray;" (tap)="clear()"></ion-icon>
    <ion-icon *ngIf="icon" item-end [name]="icon" [style.color]="iconColor"></ion-icon>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AutoCompleteCmp,
    multi: true
  }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Config, },
{type: ElementRef, },
{type: Renderer, },
{type: Form, },
{type: Item, decorators: [{ type: Optional }, ]},
{type: ModalController, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dataProvider': [{ type: Input },],
'minChar': [{ type: Input },],
'placeholder': [{ type: Input },],
'valueField': [{ type: Input },],
'textField': [{ type: Input },],
'providerParams': [{ type: Input },],
'template': [{ type: Input },],
'icon': [{ type: Input },],
'iconColor': [{ type: Input },],
'showClear': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
